import * as React from 'react';

export const LoadingMore: React.FunctionComponent = () => {
  return (
    <div className="grid-loading-more">
      <span className="ellipsis-anim">
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/LoadingMore.tsx